// One deterministic electrical model feeds both the physical scene and the SLD.
// Units: kW, kvar, kVA, kV, A. This model never writes to live telemetry.
export const round = (n, digits = 1) => Number(n.toFixed(digits))
export function split (total, weights) {
  const sum = weights.reduce((a, b) => a + b, 0)
  const result = weights.map(w => Math.floor(total * 10 * w / sum) / 10)
  result[result.length - 1] = round(total - result.slice(0, -1).reduce((a, b) => a + b, 0))
  return result
}
export function electrical (kw, voltage = 0.4, pf = 0.96) {
  const kva = kw / pf
  return { kw: round(kw), voltage, pf, kva: round(kva), amps: round(kva / (Math.sqrt(3) * voltage)), kvar: round(Math.sqrt(kva * kva - kw * kw)) }
}
export function supplyPath (model, id) {
  const device = model && model.devices.find(d => d.id === id)
  if (!device || device.kind === 'tie') return []
  const side = device.side; const n = side + 1
  const path = [
    { id: 'SOURCE' + n, name: '市电' + (side ? 'Ⅱ' : 'Ⅰ') + '路', voltage: '10 kV' },
    { id: 'AH0' + n, name: '高压进线柜', voltage: '10 kV', device: true },
    { id: 'T' + n, name: '干式变压器', voltage: '10 / 0.4 kV', device: true },
    { id: 'AA0' + n, name: '低压进线柜', voltage: '0.4 kV', device: true },
    { id: 'BUS' + n, name: (side ? 'Ⅱ' : 'Ⅰ') + '段母线', voltage: '0.4 kV' }
  ]
  if (device.kind === 'feeder') path.push({ id, name: '出线柜', voltage: device.kw + ' kW', device: true }, { id: 'LOAD-' + id, name: device.name, voltage: '末端负载 · ' + device.kw + ' kW' })
  return path
}
export function roomModel (project, number = 1) {
  if (!project) return null
  const count = Math.max(1, project.rooms)
  const weights = Array.from({ length: count }, (_, i) => count - i + 5)
  const loads = project.id === '1000107' ? split(project.load * 1000, [320, 280, 240]) : split(project.load * 1000, weights)
  const capacities = project.id === '1000107' ? split(project.capacity * 1000, [2500, 2500, 3000]) : split(project.capacity * 1000, weights)
  const roomIndex = Math.min(count - 1, Math.max(0, number - 1))
  const kw = loads[roomIndex]; const capacity = capacities[roomIndex]
  const powers = split(kw, [180, 140])
  const names = [['商业动力', '商业照明', '空调设备', '公区照明', '电梯动力', '公共设备'], ['办公动力', '办公照明', '空调设备', '公区照明', '水泵动力', '公共设备']]
  const branches = [[48, 32, 52, 18, 24, 6], [40, 28, 36, 14, 16, 6]]
  const devices = []; const transformers = []
  for (let side = 0; side < 2; side++) {
    const t = { id: 'T' + (side + 1), name: (side + 1) + '#干式变压器', kind: 'transformer', side, capacity: capacity / 2, ...electrical(powers[side]) }
    t.loss = round(t.kw * 0.012); t.loadRate = round(t.kva / t.capacity * 100, 1)
    transformers.push(t)
    devices.push({ id: 'AH0' + (side + 1), name: '10kV高压进线柜', kind: 'hv', side, ...electrical(t.kw + t.loss, 10, 0.96) }, t,
      { id: 'AA0' + (side + 1), name: '低压进线柜', kind: 'incomer', side, ...electrical(t.kw) })
    split(t.kw, branches[side]).forEach((p, index) => devices.push({ id: 'QF' + (side + 1) + String(index + 1).padStart(2, '0'), name: names[side][index], kind: 'feeder', side, index, ...electrical(p) }))
  }
  devices.push({ id: 'QF0', name: '低压母联柜', kind: 'tie', side: null, closed: false, ...electrical(0) })
  return { id: project.id + '-R' + number, projectId: project.id, number, name: project.shortName + ' · ' + String(number).padStart(2, '0') + '号配电房', capacity, kw, devices, transformers, temperature: round(25.6 + roomIndex * 0.7), humidity: 52 + roomIndex * 2, timestamp: '10:22', feeders: devices.filter(d => d.kind === 'feeder') }
}
export function roomCurve (model) {
  // Fixed demonstration snapshot. Future actual samples deliberately remain empty.
  const shape = [0.43, 0.4, 0.46, 0.42, 0.5, 0.62, 0.76, 0.82, 0.79, 0.91, 0.97, 1]
  return { labels: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '10:22', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'], series: [{ name: '配电负荷 · 10:22 快照', color: '#71c9bd', values: shape.map(w => round(model.kw * w)).concat(Array(7).fill(null)) }] }
}
